import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TrainingEnrollment, TrainingEnrollmentCreate, TrainingEnrollmentFilter } from '../data/trainingEnrollment';

export function createTrainingEnrollmentService(client: AxiosInstance) {
  return createCrudService<TrainingEnrollment, TrainingEnrollmentCreate, TrainingEnrollmentFilter>(
    client,
    '/hrm/TrainingEnrollment',
    'id',
  );
}

export type TrainingEnrollmentService = CrudService<TrainingEnrollment, TrainingEnrollmentCreate, TrainingEnrollmentFilter>;
